import { types, actions } from './requests'
export const DELETECOST_TYPES = {
    ...types('DELETECOST'),
}
export const DELETECOST_ACTIONS = {
    ...actions('DELETECOST'),
}
